// extracted by mini-css-extract-plugin
module.exports = {"root":"Benefit_root__3HNAX","icon":"Benefit_icon__CbCek","title":"Benefit_title__3FcVj","description":"Benefit_description__2Ramb"};
    if(module.hot) {
      // 1586964020200
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  